export default "__VITE_ASSET__dxw_UB0r__"